export enum MessageSourceEnum {
  SFMC_JB = 'SFMC_JB',
  API = 'API',
  TAKO_ONE = 'TAKO_ONE',
  TAKO_BULK = 'TAKO_BULK',
}
